import React, {useEffect, useState} from 'react';
import sellFactorData from "./sellFactorData"
import ObjectDataHolder from "../Hooks/ObjectDataHolder";
import SellFactorKOL from "./FactorKOL/SellFactorKOL";
import SellFactorJOZ from "./FactorJOZ/SellFactorJOZ";
import Loader from "../Loader";
import _axios from "../../httpService"
import {prefixUrl} from "../../utils/utilsData";
import {useLocation, useNavigate} from "react-router-dom";
import utilsFunction from "../../utils/utilsFunction";
import {calculateSumOfEachRow} from "./SellFactorFunctions";
import Swal from "sweetalert2";
import "./SellFactor.scss";
import useTitle from "../Hooks/useTitle";

// Backend sometimes returns bank as [] when no accounts exist — normalize to a safe object
const normalizeBank = (bank) => {
  if (!bank || Array.isArray(bank) || !bank.id) {
    return {id: "", name: "انتخاب بانک"};
  }
  return bank;
};

const SellFactor = () => {

  useTitle("فاکتور فروش");
  const myLocation = useLocation();
  const navigateTo = useNavigate()
  const [sendData, setSendData] = ObjectDataHolder();
  const [initialData, setInitialData] = ObjectDataHolder();
  const [componentData, setComponentData] = ObjectDataHolder();
  const [loading, setLoading] = useState(true);
  const [reRender, setReRender] = useState(0)

  useEffect(() => {
    if (prefixUrl() === null) {
      window.location.reload()
    }

    if (myLocation?.state?.id) {
      const id = myLocation.state.id
      _axios.get(prefixUrl() + "/clothingShopFactor/?request=factorSubmittedData&factorId=" + id).then(res => {

        const data = res.data;
        if (data.status) {

          setInitialData(data.data.initialData)
          setComponentData(sellFactorData.componentData);

          const temp = {...data.data.factorData}

          temp.priceData.forEach(v => {
            v.uniqId = utilsFunction.randomNumberGenerator();
          })

          temp.tableData = calculateSumOfEachRow(temp.tableData)
          // temp.tableData = calculateSumOfTableData(temp.tableData)

          setSendData({
            ...temp,
            bank: normalizeBank(data.data.initialData.bank),
            tax: data.data.initialData.tax,
            showOrderId: data.data.initialData.showOrderId
          })
          setLoading(false)
        } else {
          setComponentData({hasAccessToStoreRoom: data.status, showMessageIfHasNotAccessToStoreRoom: data.message})
          setLoading(false)
          Swal.fire({
            title: data.message,
            text: "لطفا بعد از اعمال تغییرات مجددا تلاش کنید.",
            icon: 'error',
            showCancelButton: false,
            allowOutsideClick: true,
            showConfirmButton: true,
            confirmButtonText: 'برو به داشبورد'
          }).then((result) => {
            if (result.isConfirmed) {
              navigateTo("/dashboard")
            }
          })
        }
      })

    } else {
      _axios.get(prefixUrl() + "/clothingShopFactor/?request=initialData").then(res => {

        const data = res.data;
        if (data.status) {
          setSendData({
            ...sellFactorData.initialSendData,
            bank: normalizeBank(data.data.bank),
            tax: data.data.tax,
            showOrderId: data.data.showOrderId
          })
          // setSendData({...sendData, bank: data.data.bank})
          setInitialData(data.data)

          setComponentData(sellFactorData.componentData);
          setLoading(false)
        } else {
          setComponentData({hasAccessToStoreRoom: data.status, showMessageIfHasNotAccessToStoreRoom: data.message})
          setLoading(false)
          Swal.fire({
            title: data.message,
            text: "لطفا بعد از اعمال تغییرات مجددا تلاش کنید.",
            icon: 'error',
            showCancelButton: false,
            allowOutsideClick: true,
            showConfirmButton: true,
            confirmButtonText: 'برو به داشبورد'
          }).then((result) => {
            if (result.isConfirmed) {
              navigateTo("/dashboard")
            }
          })
        }
      })
    }
  }, [])

  useEffect(() => {
    if (reRender !== 0) {
      _axios.get(prefixUrl() + "/clothingShopFactor/?request=initialData").then(res => {
        const data = res.data;
        if (data.status) {
          setSendData({
            ...sellFactorData.initialSendData,
            bank: normalizeBank(data.data.bank),
            tax: data.data.tax,
            showOrderId: data.data.showOrderId
          })
          setInitialData(data.data)
        }
      })
    }
  }, [reRender]);

  try {
    return (
      <>
        {loading ? <div className={"loader-pos"}><Loader/></div> :
          <div className={"msf-13"}>
            {componentData.hasAccessToStoreRoom !== false ?
              <>
                <SellFactorKOL
                  sendData={sendData}
                  setSendData={setSendData}
                  initialData={initialData}
                  componentData={componentData}
                  setComponentData={setComponentData}
                  setReRender={setReRender}
                />
                <SellFactorJOZ
                  sendData={sendData}
                  setSendData={setSendData}
                  initialData={initialData}
                  componentData={componentData}
                  setComponentData={setComponentData}
                />
              </>
              : <h2>{componentData.showMessageIfHasNotAccessToStoreRoom}</h2>}
          </div>}
      </>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default React.memo(SellFactor);
